import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const JOBS = [
  { id: 1, title: 'Senior Operations Manager', department: 'Logistics', location: 'Accra, Ghana', type: 'Full-time', salary: 'GHS 8k - 12k', date: '2 days ago' },
  { id: 2, title: 'Executive Assistant', department: 'Administration', location: 'Kumasi, Ghana', type: 'Full-time', salary: 'GHS 4k - 6k', date: '3 days ago' },
  { id: 3, title: 'Site Supervisor', department: 'Construction', location: 'Takoradi, Ghana', type: 'Contract', salary: 'Negotiable', date: '1 week ago' },
  { id: 4, title: 'Sales Executive', department: 'Marketing', location: 'Accra, Ghana', type: 'Full-time', salary: 'Commission Based', date: '5 days ago' },
  { id: 5, title: 'Warehouse Manager', department: 'Logistics', location: 'Tema, Ghana', type: 'Full-time', salary: 'GHS 6k - 9k', date: 'Just now' },
];

const CandidateDashboard = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filter, setFilter] = useState('All');

  const filteredJobs = JOBS.filter(job => 
    (job.title.toLowerCase().includes(searchTerm.toLowerCase()) || 
     job.department.toLowerCase().includes(searchTerm.toLowerCase())) &&
    (filter === 'All' || job.type === filter)
  );

  return (
    <div className="space-y-8">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Welcome back, Yaw!</h1>
          <p className="text-gray-500">Find your next career opportunity with RM Ghana.</p>
        </div>
        <div className="flex gap-3">
          <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 flex items-center gap-4">
            <div className="w-10 h-10 rounded-full bg-green-50 text-green-600 flex items-center justify-center">
              <SafeIcon name="CheckCircle" size={20} />
            </div>
            <div>
              <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Applied</p>
              <p className="text-lg font-bold text-gray-800">12 Jobs</p>
            </div>
          </div>
          <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 flex items-center gap-4">
            <div className="w-10 h-10 rounded-full bg-blue-50 text-[#11469A] flex items-center justify-center">
              <SafeIcon name="Clock" size={20} />
            </div>
            <div>
              <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Interviews</p>
              <p className="text-lg font-bold text-gray-800">2 Pending</p>
            </div>
          </div>
        </div>
      </div>

      {/* Search and Filters */}
      <div className="bg-white p-4 rounded-2xl shadow-sm border border-gray-100 flex flex-col md:flex-row gap-4">
        <div className="flex-1 relative">
          <SafeIcon name="Search" className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" size={20} />
          <input 
            type="text" 
            placeholder="Search for job titles, keywords or companies..." 
            className="w-full pl-12 pr-4 py-3 bg-gray-50 border border-transparent focus:border-[#11469A] focus:bg-white rounded-xl outline-none transition-all"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="flex gap-2">
          {['All', 'Full-time', 'Contract'].map((type) => (
            <button
              key={type}
              onClick={() => setFilter(type)}
              className={`px-6 py-3 rounded-xl font-bold text-sm transition-all ${filter === type ? 'bg-[#11469A] text-white shadow-md' : 'bg-gray-50 text-gray-500 hover:bg-gray-100'}`}
            >
              {type}
            </button>
          ))}
        </div>
      </div>

      {/* Job Listings */}
      <div className="grid grid-cols-1 gap-4">
        {filteredJobs.length > 0 ? (
          filteredJobs.map((job, idx) => (
            <motion.div
              key={job.id}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: idx * 0.05 }}
              className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md hover:border-blue-100 transition-all group flex flex-col md:flex-row justify-between items-start md:items-center gap-6"
            >
              <div className="flex items-center gap-5">
                <div className="w-14 h-14 rounded-2xl bg-gray-50 flex items-center justify-center text-[#11469A] group-hover:bg-blue-50 transition-colors">
                  <SafeIcon name="Briefcase" size={24} />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-800 group-hover:text-[#11469A] transition-colors">{job.title}</h3>
                  <div className="flex flex-wrap gap-x-4 gap-y-1 mt-1">
                    <span className="text-sm text-gray-400 flex items-center gap-1.5"><SafeIcon name="MapPin" size={14} /> {job.location}</span>
                    <span className="text-sm text-gray-400 flex items-center gap-1.5"><SafeIcon name="Tag" size={14} /> {job.department}</span>
                    <span className="text-sm text-[#00AEEF] font-bold">{job.salary}</span>
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-4 w-full md:w-auto border-t md:border-0 pt-4 md:pt-0">
                <div className="flex-1 md:text-right">
                  <p className="text-xs font-bold text-gray-400 uppercase tracking-widest">{job.type}</p>
                  <p className="text-xs text-gray-400 mt-0.5">Posted {job.date}</p>
                </div>
                <button className="px-6 py-2.5 bg-[#11469A] hover:bg-[#00AEEF] text-white rounded-xl font-bold text-sm transition-all whitespace-nowrap">
                  Apply Now
                </button>
              </div>
            </motion.div>
          ))
        ) : (
          <div className="text-center py-20 bg-white rounded-2xl border border-dashed border-gray-200">
            <SafeIcon name="Inbox" size={48} className="mx-auto text-gray-300 mb-4" />
            <p className="text-gray-500 font-medium">No jobs found matching your criteria.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CandidateDashboard;